import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { editNewsAndEventsRequest, editNewsAndEventsRequestError, editNewsAndEventsRequestSuccess } from '../../slices/NewsAndEvents/EditNewsAndEventsSlice';

export const EditNewsAndEventsAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(editNewsAndEventsRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.editNewsAndEvents,
                data: data,
            })
            return dispatch(editNewsAndEventsRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(editNewsAndEventsRequestError(_error));
        }
    };
};
